// src/utils/tools.js

// Base64 加密（支持中文）
export const encodeBase64 = (str:string) => {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode(parseInt(p1, 16))))
}

// Base64 解密（如果需要反向解析）
export const decodeBase64 = (str:string) => {
  return decodeURIComponent(atob(str))
}
